import React from "react";
import './Map.css';

function Map() {
    return(
        <div>
            <h2>Map</h2>
            <div id="mapContainer">
                <div style={{width: "100%"}}><iframe id="map" title="map" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=3353%20Fort%20St,%20Wyandotte,%20MI%2048192+(Quit-n-Time)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed" width="100%" height="600" frameborder="0"><a href="https://www.maps.ie/distance-area-calculator.html">distance maps</a></iframe></div>
            </div>
        </div>
    )
}

export default Map;